module.exports = __webpack_public_path__ + "american-express.png";